import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Button, IconButton, Typography, Box } from '@mui/material';
import LogoutModal from "./modals/LogoutModal";
import { logout } from "../utils/auth";

const NavbarContainer = styled('div')({
    backgroundColor: '#FFFFFF',
    padding: '16px 24px',
    position: 'sticky',
    top: 0,
    zIndex: 1100,
    borderBottom: '1px solid #E0E0E0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
});

const LogoutButton = styled(Button)({
    backgroundColor: '#12188A',
    color: 'white',
    width: '116px',
    height: '44px',
    borderRadius: '52px',
    textTransform: 'none',
    padding: '6px 10px',
    fontSize: '14px',
    fontFamily: 'Urbanist',
    fontWeight: 500,
    '&:hover': {
        backgroundColor: '#12188A',
    },
    '& .MuiButton-endIcon': {
        marginLeft: '4px',
    },
});

const Navbar = ({ title, onBack, onLogout }) => {
    const navigate = useNavigate();
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const handleLogoutClick = () => {
        setShowLogoutModal(true);
      };
    
      const handleLogoutConfirm = async () => {
        setIsLoggingOut(true);
        try {
          // Add a small delay for better UX (optional)
          await new Promise(resolve => setTimeout(resolve, 500));
          await logout(navigate);
        } catch (error) {
          console.error('Logout error:', error);
        } finally {
          setIsLoggingOut(false);
          setShowLogoutModal(false);
        }
      };
    
      const handleLogoutCancel = () => {
        if (!isLoggingOut) {
          setShowLogoutModal(false);
        }
      };

    return (
        <NavbarContainer>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {/* <BackButton onClick={handleBack}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="28" viewBox="0 0 16 28" fill="none">
            <path d="M14 2L2 14L14 26" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </BackButton>
        <NavbarTitle variant="h6">{title}</NavbarTitle> */}
            </Box>
            <LogoutButton
                variant="contained"
                endIcon={
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M6.75 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H6.75M12 13.5L15.75 9M15.75 9L12 4.5M15.75 9H6.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                }
                onClick={handleLogoutClick}
            >
                Logout
            </LogoutButton>
            <LogoutModal
                open={showLogoutModal}
                onClose={handleLogoutCancel}
                onLogout={handleLogoutConfirm}
                isLoggingOut={isLoggingOut}
            />
        </NavbarContainer>
    );
};

export default Navbar;
